import { ConfigurationDropdown } from "@/types";

const dropdownDependenciesCheck = (
  dropdown: ConfigurationDropdown,
  dropdownsValues: { [key: string]: string | string[] | null },
  dropdowns: ConfigurationDropdown[],
): boolean => {
  if (!dropdown.depends_on || dropdown.depends_on.length === 0) {
    return true; // No dependencies, always show
  }

  const logic = dropdown.logic || "all";

  const dependencyChecks = dropdown.depends_on.map((dependency) => {
    const selectedValue = dropdownsValues?.[dependency.key];

    if (!selectedValue || typeof selectedValue !== "string") {
      return false; // Dependency not selected or invalid type
    }

    // Find the selected option in the dependency dropdown
    const dependencyDropdown = dropdowns.find((d) => d.key === dependency.key);
    const selectedOption = dependencyDropdown?.options.find(
      (opt) => opt.key === selectedValue,
    );

    if (!selectedOption) {
      return false; // Selected option not found
    }

    // Check if the field value matches the expected value
    type OptionWithField = typeof selectedOption & Record<string, unknown>;
    const fieldValue = (selectedOption as OptionWithField)[dependency.field];
    return fieldValue === dependency.value;
  });

  // Apply logic (all or any)
  return logic === "all"
    ? dependencyChecks.every(Boolean)
    : dependencyChecks.some(Boolean);
};
export default dropdownDependenciesCheck;
